// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Places from '../../map/Places';
import SingleMap from '../../map/SingleMap';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignLocation(props) {
	const classes = useStyles();
	const { sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	const [mySign, setMySign] = React.useState({
		geo_location : '-117.8027955, 33.86.25262',
		address: '',
		timeZone: 'America/Los_Angeles'
	});
	const [changed, setChanged] = React.useState(false);
	const zones = [
		{
			name: 'Hawaii',
			value: 'Pacific/Honolulu'
		}, {
			name: 'Alaska',
			value: 'America/Anchorage'
			
		}, {
			name: 'Pacific Time',
			value: 'America/Los_Angeles'
		}, {
			name: 'Arizona',
			value: 'America/Phoenix'
		}, {
			name: 'Mountain Time',
			value: 'America/Denver'
		}, {
			name: 'Central Time',
			value: 'America/Tegucigalpa'
		}, {
			name: 'Eastern Time',
			value: 'America/New_York'
		}, {
			value: 'America/Caracas'
		}, {
			name: 'Atlantic Time', 
			value: 'America/Halifax'
		}, {
			value: 'America/St_Johns',
		}, {
			value: 'America/Argentina/Buenos_Aires'
		}, {
			value: 'America/Sao_Paulo'
		}, {
			value: 'Atlantic/South_Georgia'
		}, {
			value: 'Atlantic/Azores'
		}, {
			value: 'Europe/Dublin'
		}, {
			value: 'Europe/Belgrade'
		}, {
			value: 'Europe/Minsk'
		}, {
			value: 'Asia/Kuwait'
		}, {
			value: 'Asia/Tehran'
		}, {
			value: 'Asia/Muscat'
		}, {
			value: 'Asia/Yekaterinburg'
		}, {
			value: 'Asia/Kolkata'
		}, {
			value: 'Asia/Katmandu'
		}, {
			value: 'Asia/Dhaka'
		}, {
			value: 'Asia/Rangoon'
		}, {
			value: 'Asia/Krasnoyarsk'
		}, {
			value: 'Asia/Brunei'
		}, {
			value: 'Asia/Seoul'
		}, {
			value: 'Australia/Darwin'
		}, {
			value: 'Australia/Canberra'
		}, {
			value: 'Asia/Magadan'
		}, {
			value: 'Pacific/Fiji'
		}, {
			value: 'Pacific/Tongatapu'
		}, {
			value: 'Kwajalein'
		}, {
			value: 'Pacific/Midway'
		}
	];
	
	//update the view when props change
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			//only copy the relevant values
			setMySign({
				geo_location: sign.geo_location,
				address: sign.address,
				timeZone: sign.timeZone,
				id: sign.id
			});
		}
	}, [sign, signId, setSignId, setMySign]);
	
	
	
	
	//whenever values change, update the parent
	React.useEffect(() => {
		if(changed){
			//console.log('sign changed', mySign);
			if(onChange) onChange(mySign);
			return setChanged(false);
		}
	}, [mySign, changed, onChange]);
	
	//handler for dragging the map pointer
	const handleDragPointer = (geoloc, address) =>{
		var newSign = Object.assign(mySign, {
			geo_location : geoloc,
			address: address
		})
		setMySign(newSign);
		setChanged(true);
	}
	
	
	//handle change any value
	const handleChangeTZ = (e) => {
		var newSign = Object.assign(mySign, {
			timeZone : e.target.value
		});
		//console.log('changed timezone', newSign);
		setMySign(newSign);
		setChanged(true);
	}
	
	//handle change the place value
	const handleChangePlace = (val) => {
		//console.log('NEW PLACE', val);
		var newSign = Object.assign(mySign, val);
		//console.log('place changed', newSign);
		setMySign(newSign);
		setChanged(true);
		//setPlace(val.address);
	}
	
	return (
		<Card className={classes.root}>
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<Places
							value={mySign.address}
							label='Address'
							onChange={handleChangePlace}
							name='place'
						/>
				
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_tz"
							name="timeZone"
							label="Time Zone"
							value={mySign.timeZone}
							onChange={handleChangeTZ}
							fullWidth
							select
						>
							{zones.map((row, i) => (
							<MenuItem value={row.value} key={i}>{row.name ? row.name : row.value}</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item xs={12}>
						<SingleMap geo_location={mySign.geo_location} onDrag={handleDragPointer} />
					</Grid>
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
